import {
  WALLET_AC_REQUIRED_SUCCESS,
  WALLET_AC_REQUIRED_FAILED,
  RESET_WALLET_AC_REQUIRED,
  LOADING_WALLET_AC_REQUIRED,
  NETWORK_ERROR_WALLET_AC_REQUIRED,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_WALLET_AC_REQUIRED:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
      };
    case WALLET_AC_REQUIRED_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
      };
    case WALLET_AC_REQUIRED_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
      };
    case NETWORK_ERROR_WALLET_AC_REQUIRED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
      };
    case RESET_WALLET_AC_REQUIRED:
      return (state = initialState);
    default:
      return state;
  }
};
